import React, { useRef } from "react";
import { toJpeg } from "html-to-image";
import jsPDF from "jspdf";
import { IoMdClose } from "react-icons/io";
import { CiReceipt } from "react-icons/ci";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { IoCloseCircleSharp } from "react-icons/io5";
import logoGrey from "../../Contents/images/o/logo-grey.png"
import { useStateValue } from "../../Utils/StateProvider";
import { capitalizeWords, formatToCurrency } from "../../Utils/general";

const TransactionReceipt = ({ transaction, closeMethod }) => {
    const [{ customer }] = useStateValue()
    const receiptRef = useRef();
    
    const handleDownloadJPEG = () => {
        if (receiptRef.current) {
            toJpeg(receiptRef.current, { quality: 0.95 })
                .then((dataUrl) => {
                    const link = document.createElement("a");
                    link.href = dataUrl;
                    link.download = `transaction-receipt-${transaction?.tid.slice(transaction?.tid.length - 6, transaction?.tid.length)}.jpeg`;
                    link.click();
                })
                .catch((error) => console.error("Failed to download as JPEG:", error));
        }
    };

    const handleDownloadPDF = () => {
        if (receiptRef.current) {
            console.log(receiptRef.current)
            toJpeg(receiptRef.current, { quality: 0.95 })
                .then((dataUrl) => {
                    const pdf = new jsPDF();
                    const imgProps = pdf.getImageProperties(dataUrl);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    pdf.addImage(dataUrl, "JPEG", 0, 0, pdfWidth, pdfHeight);
                    pdf.save(`transaction-receipt-${transaction?.tid.slice(transaction?.tid.length - 6, transaction?.tid.length)}.pdf`);
                })
                .catch((error) => console.error("Failed to download as PDF:", error));
        }
    };

    return (
        <div className="backdrop">
            <IoMdClose className="floating-cls-btn" onClick={closeMethod} />
            <div>
                <div
                    style={{
                        maxWidth: "450px",
                        height: "100vh",
                        maxHeight: 600,
                        margin: "auto",
                        fontFamily: "Helvitica Arial, sans-serif",
                        overflowY: "auto"
                    }}
                >
                    {/* Receipt Display */}
                    <div
                        ref={receiptRef}
                        style={{
                            border: "1px solid #ddd",
                            padding: "20px",
                            width: "100%",
                            backgroundColor: "#fff",
                        }}
                    >
                        {/* <div 
                        style={{
                            position: "relative",
                            width: "450px",
                            height: "fit",
                            backgroundColor: "red",
                            backgroundImage: "url(../../Contents/images/o/logo-grey.png)",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "contain",
                            opacity: 0.2,
                        }}
                    ></div> */}
                        <h2 style={{ textAlign: "center" }}>Transaction Receipt</h2>
                        <img style={{ margin: "auto" }} src={logoGrey} alt="" height={50} />
                        <hr />
                        <CiReceipt style={{ height: 30, width: 30, margin: "0 auto", color: transaction.status ? "green" : "red" }} />
                        <p style={{ borderBottom: "0.5px solid #ddd", color: "#666", padding: 10 }}>
                            <h3>Account No. {customer.account}</h3>
                            <p><h3>{capitalizeWords(customer?.fname)} {capitalizeWords(customer?.lname)}</h3></p>
                        </p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 10,
                            borderBottom: "0.5px solid #ddd",
                            fontSize: 14
                        }}>{capitalizeWords(transaction.transaction_type)} Transaction</p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 10,
                            borderBottom: "0.5px solid #ddd",
                            fontSize: 14
                        }}>
                            <strong>Transaction ID:</strong> <span style={{ fontSize: 10, fontWeight: 600 }}>{transaction.tid}</span></p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 10,
                            borderBottom: "0.5px solid #ddd",
                            fontSize: 14
                        }}>
                            <strong>Date:</strong> <span style={{ fontSize: 10, fontWeight: 600 }}>{new Date(transaction.timestamp).toLocaleString()}</span></p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 10,
                            borderBottom: "0.5px solid #ddd",
                            fontSize: 14
                        }}>
                            <strong>Amount:</strong> <span style={{ fontSize: 10, fontWeight: 600 }}>{formatToCurrency(transaction.amount, customer.currency)}</span></p>
                        <p style={{
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between",
                            padding: 10,
                            borderBottom: "0.5px solid #ddd",
                            fontSize: 14,
                            backgroundColor: "#ddd"
                        }}>
                            <strong>Status:</strong>
                            <div>
                                <span style={{ fontSize: 10, fontWeight: 600, color: transaction.status ? "green" : "red" }}>
                                    {transaction?.status ? <IoMdCheckmarkCircle /> : <IoCloseCircleSharp />} {transaction.status ? "Successful" : "Failed"}
                                </span><br />
                                <div style={{ fontSize: 10 }}>
                                    <div><strong style={{ fontStyle: "italic", color: "#666" }}>Ref</strong>: {transaction?.tid.replace("TID-", "")}</div>
                                    <div><strong style={{ fontStyle: "italic", color: "#666" }}>Date</strong>: {new Date(transaction.timestamp).toDateString()}</div>
                                </div>
                            </div>
                        </p>
                        <p style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: 10,
                            fontSize: 14
                        }}>
                            <strong>Description:</strong> <span style={{ fontSize: 10, fontWeight: 600 }}>{transaction.description}</span></p>
                    </div>

                    {/* Download Options */}
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <button
                            onClick={handleDownloadJPEG}
                            style={{ margin: "5px", padding: "10px 20px", cursor: "pointer" }}
                        >
                            Download as JPEG
                        </button>
                        <button
                            onClick={handleDownloadPDF}
                            style={{ margin: "5px", padding: "10px 20px", cursor: "pointer" }}
                        >
                            Download as PDF
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransactionReceipt;
